import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function BrowserPage() {
  return <AppPagePlaceholder name="Browser" />;
}
